<template>
<div>
  <el-row :gutter="20">
    <el-col :span="16">
      <!-- <el-input size="small"  v-model="tempFuMal" :readonly="true"></el-input>
    </el-col>
    <el-col :span="8"> -->
      <!-- <popover ref="Popover" :table-data="data.modelkey__obj" @funcBtnClick="funcBtnClick" />  -->
      <el-popover placement="top" width="400" v-model="visible">
        <el-row >
          <el-col :span="8">
            <el-table :data="tableData" style="width: 100%; height:250px;overflow:auto" @row-click="fieldclick" >
              <el-table-column prop="name" label="字段">
                <template slot-scope="scope">
                  {{scope.row.name}}
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="16">
            <div id="numberPane" style="float:left;width:250px;height:250px;">
              <div class="panel panel-default"><div class="panel-body compute-div" value="1" @click ="numberclick">1</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="2" @click ="numberclick">2</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="3" @click ="numberclick">3</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="+" @click ="numberclick">+</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="4" @click ="numberclick">4</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="5" @click ="numberclick">5</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="6" @click ="numberclick">6</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="-" @click ="numberclick">-</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="7" @click ="numberclick">7</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="8" @click ="numberclick">8</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="9" @click ="numberclick">9</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="*" @click ="numberclick">*</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="0" @click ="numberclick">0</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="(" @click ="numberclick">(</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value=")" @click ="numberclick">)</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="/" @click ="numberclick">÷</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="." @click ="numberclick">.</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="clear" @click ="numberclick">清空</div></div>
              <div class="panel panel-default"><div class="panel-body compute-div" value="del" @click ="numberclick">←</div></div>
              <div class="panel panel-primary"><div class="panel-body" style="cursor: pointer;" @click="visible = false">确定</div></div>
            </div>
          </el-col>
        </el-row>
        <div style="text-align: right; margin: 0">
        <!-- <el-button size="mini" type="primary" @click="visible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="visible = false">确定</el-button> -->
        </div>
        <el-button slot="reference"  type="primary" size="small">选择</el-button>
      </el-popover>
    </el-col>
  </el-row>
  <el-row :gutter="20">
    <el-col :span="24"><el-input size="small" type="textarea" v-model="tempFuMal" :readonly="true"></el-input></el-col>
  </el-row>
</div>
</template>
<script>
export default {
  name: 'popover',
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      }
    },
    fuMal: {
      type: String,
      default: ''
    },
    fuMalkey: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    tempFuMalkey: {
      get() {
        return this.fuMalkey;
      },
      set(val) {
        this.$emit('update:fuMalkey', val);
      }
    },
    tempFuMal: {
      get() {
        return this.fuMal;
      },
      set(val) {
        this.$emit('update:fuMal', val);
      }
    }

  },
  data() {
    return {
      formulaList: [],
      visible: false
    };
  },
  watch: {
    tableData: {
      deep: true,
      handler(val) {
      }
    }
  },
  created() {
  },
  methods: {
    fieldclick(row, column, event) {
      const fuMalkey = this.tempFuMalkey.map(m => ({ ...m }));
      fuMalkey.push(row);
      let [fuMal] = [''];
      fuMalkey.map(item => {
        fuMal += item.name;
      });
      this.tempFuMalkey = fuMalkey;
      this.tempFuMal = fuMal;
      // console.log(row)
    },
    numberclick(event) {
      const fuMalkey = this.tempFuMalkey.map(m => ({ ...m }));
      if (event.target.textContent === '←') {
        fuMalkey.pop();
      } else if (event.target.textContent === '清空') {
        fuMalkey.splice(0);
      } else {
        fuMalkey.push({ key: event.target.textContent, name: event.target.textContent });
      }
      let [fuMal] = [''];
      fuMalkey.map(item => {
        fuMal += item.name;
      });
      this.tempFuMalkey = fuMalkey;
      this.tempFuMal = fuMal;
      // console.log(event)
    }
  }
};
</script>
<style>
.outBox{
  height: 250px;
  overflow-y: auto;
  border: 1px solid black;
  font-size-adjust: 30px;
}
#numberPane>.panel{
float:left;
width:50px;
padding:2;
height:25px;
margin-left:5px;
}
#numberPane>.panel>.panel-body{
text-align:center;
padding:0;
font-size:15px;
}
.panel {
    margin-bottom: 17px;
    background-color: #fff;
    border: 1px solid transparent;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
.panel {
    border: 0;
    border-bottom: 1px solid #DDD;
    box-shadow: 0 0 0 #fff;
}
/* .compute-div{cursor:Pointer;}
.list-group-item.datetime, .list-group-item.date {
	color: rgb(66, 139, 202);
}
.list-group-item{
	cursor: pointer;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow:hidden;
	width:150px;
}
.list-group-item:HOVER {
	background: rgb(66,139,202);
	color: white;
}*/
</style>
